import { render, staticRenderFns } from "./VitalsSurveyWelcome.vue?vue&type=template&id=4cd5d3d1&scoped=true&"
import script from "./VitalsSurveyWelcome.vue?vue&type=script&lang=js&"
export * from "./VitalsSurveyWelcome.vue?vue&type=script&lang=js&"
import style0 from "./VitalsSurveyWelcome.vue?vue&type=style&index=0&id=4cd5d3d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5d3d1",
  null
  
)

export default component.exports